import { Attendance } from "@/@types/esus/Attendance";
import { HealthTeam } from "@/@types/esus/HealthTeam";
import { HealthUnit } from "@/@types/esus/HealthUnit";
import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";
import { IndicatorEsfStatusEnum } from "@/utils/enums/IndicatorEsfStatusEnum";

export type DetailedCitizensAttendancesIndicatorC6Params = Partial<PaginationFilter> & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	ine?: string;
	isEvaluated?: boolean;
	export?: boolean;
};

export class DetailedCitizenAttendancesIndicatorC6Data {
	id: number = 0;
	cpf?: string;
	cns?: string;
	birthdate: string = "";
	fullName: string = "";
	healthUnitId: number = 0;
	healthTeamId: number = 0;
	healthUnit?: HealthUnit;
	healthTeam?: HealthTeam;
	area?: string;
	motherName?: string;
	gender?: number;
	street?: string;
	houseNumber?: string;
	neighborhood?: string;
	phone?: string;
	attendances?: Attendance[];
	lastAttendance?: Attendance;
	lastAttendanceStatus: IndicatorEsfStatusEnum = IndicatorEsfStatusEnum.Lost;
	twoWeightAndHeightMetricsRegistersStatus: IndicatorEsfStatusEnum = IndicatorEsfStatusEnum.Lost;
	weightAndHeightMetricsRegisters?: Attendance[];
}

export async function getDetailedCitizensAttendancesIndicatorC6({
	uf,
	ibgeCode,
	...params
}: DetailedCitizensAttendancesIndicatorC6Params) {
	const response = await esusApi.get<Paginated<DetailedCitizenAttendancesIndicatorC6Data>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c6/detailed-citizens-attendances`,
		params
	);
	return response.data ?? new Paginated<DetailedCitizenAttendancesIndicatorC6Data>();
}
